import React, { useContext } from 'react'
import { Loader } from '@saatva-bits/pattern-library.components.loader'
import RecommendedProducts from '@/components/RecommendedProducts'
import { CartContext } from '@/store/cart'
import styles from './styles.module.scss'
import className from 'classnames'

const RecommendedProductsSection = () => {
    const { isLoadingRecommendedProducts } = useContext(CartContext)
    const recommendedProductsClasses = className(styles.recommendedProducts)

    return (
        <div className={recommendedProductsClasses}>
            <>
                <h3 className={styles.subtitle}>Others also bought</h3>
                {isLoadingRecommendedProducts ? <Loader /> : <RecommendedProducts />}
            </>
        </div>
    )
}

export default RecommendedProductsSection
